<app-tutor-menu>
  <nb-card>
    <nb-card-header>
      <h4>{{ "pages.tutors.tabGeneral" | translate }}</h4>
    </nb-card-header>
    <nb-card-body>
      <app-assistant-settings-form [data]="tutor"></app-assistant-settings-form>
    </nb-card-body>
  </nb-card>
</app-tutor-menu>
